import { Component, Input } from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { AppOnlineStateService } from "@main/pwa/app-online-state.service";
import { ControlBase } from "./control-base";

@Component({
    selector: "m-select-date",
    template: `
        <div *ngIf="showValue; else buttons_only" class="p-inputgroup">
            <input type="text" pInputText [ngModel]="visibleDate" class="__date-input" readonly />
            <span class="p-buttonset m-buttonset-rounded">
                <p-button
                    allowOffline
                    label="Today"
                    styleClass="__today-button-aside"
                    [disabled]="_isDateDisabled"
                    (onClick)="_selectToday()"></p-button>
                <p-button
                    allowOffline
                    iconPos="right"
                    icon="pi pi-calendar"
                    [disabled]="_isDateDisabled"
                    (onClick)="datePicker.toggle()"
                    class="calendar-button"></p-button>

                <p-calendar
                    allowOffline
                    #datePicker
                    allowOffline
                    styleClass="__m-select-date-picker"
                    [ngModel]="date"
                    (ngModelChange)="onDateChanged($event)"
                    appendTo="body"
                    [readonlyInput]="true"
                    [showOnFocus]="false"
                    [maxDate]="maxDate"
                    [minDate]="minDate"></p-calendar>
            </span>
        </div>
        <ng-template #buttons_only>
            <span class="p-buttonset m-buttonset-rounded">
                <p-button
                    allowOffline
                    label="Today"
                    styleClass="__today-button"
                    [disabled]="_isDateDisabled"
                    (onClick)="_selectToday()"></p-button>

                <p-button
                    allowOffline
                    iconPos="right"
                    icon="pi pi-calendar"
                    [disabled]="_isDateDisabled"
                    (onClick)="datePicker.toggle()"
                    class="calendar-button"></p-button>

                <p-calendar
                    #datePicker
                    styleClass="__m-select-date-picker"
                    [ngModel]="date"
                    (ngModelChange)="onDateChanged($event)"
                    appendTo="body"
                    [readonlyInput]="true"
                    [showOnFocus]="false"
                    [maxDate]="maxDate"></p-calendar>
            </span>
        </ng-template>
    `,
    styleUrls: ["./select-date-control.component.scss"],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: SelectDateControlComponent,
            multi: true
        }
    ]
})
export class SelectDateControlComponent extends ControlBase<Date> {
    date = new Date();
    private _disabled: boolean = false;
    
    @Input() set disabled(disabled: boolean) {
        this._disabled = disabled;
        this.setDisabledState(disabled);
    }
    get disabled() {
        return this._disabled;
    }
    @Input() allowOffline: boolean;
    @Input() showValue: boolean = false;
    @Input() maxDate: Date = null;
    @Input() minDate: Date = null;

    constructor(private appOnlineService: AppOnlineStateService) {
        super();
    }

    onDateChanged(date: Date) {
        this.date = date;
        this.onChange(this.date);
    }

    writeValue(obj: Date): void {
        this.date = obj;
    }

    _selectToday() {
        this.onDateChanged(new Date());
    }

    get _isDateDisabled() {
        return this._disabled || (!this.appOnlineService.isAppOnline && this.allowOffline == null);
    }

    get visibleDate() {
        return this.date?.toLocaleDateString("en-GB");
    }
}
